import { translateZodFieldMessage } from '@/shared/utils/formZod.utils';
import type { FieldError as RHFFieldError, FieldErrors } from 'react-hook-form';

/** Acessa erro em caminho aninhado (ex.: `usuario.papel.id`) sem conflito de tipos do RHF. */
export function getNestedFieldError(
  errors: FieldErrors | undefined,
  path: string,
): RHFFieldError | undefined {
  if (!errors) return undefined;

  let current: unknown = errors;
  for (const part of path.split('.')) {
    if (current == null || typeof current !== 'object') return undefined;
    current = (current as Record<string, unknown>)[part];
  }

  if (current && typeof current === 'object' && 'message' in current) {
    return current as RHFFieldError;
  }

  return undefined;
}

export function hasNestedFieldError(errors: FieldErrors | undefined, path: string): boolean {
  return !!getNestedFieldError(errors, path);
}

export function formControlClass(isInvalid: boolean): string {
  return isInvalid ? 'form-control is-invalid' : 'form-control';
}

export function formSelectClass(isInvalid: boolean): string {
  return isInvalid ? 'form-select is-invalid' : 'form-select';
}

export function FieldError({ message }: { message?: string }) {
  const text = translateZodFieldMessage(message);
  if (!text) return null;
  return <div className="invalid-feedback d-block">{text}</div>;
}
